// GENERATED by scripts/stamp-build.js at build time (npm `prebuild`). Do not edit.
//
// The value committed to the repo is a PLACEHOLDER and says so in `source`. Every build
// overwrites this file, so a bundle whose source is `placeholder` was never stamped and a
// bundle whose source is `unresolved` was stamped where no commit could be determined.
export const buildInfo = {
  "sha": "3abf8631733a9597f06f91de6fd2f95385693110",
  "source": "cloudflare-pages",
  "builtAt": "2026-11-04T03:06:37.443Z"
};

export default buildInfo;
